import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const imgStyle = {
  width: '35px',
  height: '35px',
}

class ImageEmployee extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return <div><img src={'https://secure.gravatar.com/avatar/' + this.props.gravatar + '?s=80'} alt={this.props.name} className="gravatar" style={imgStyle} /></div>
  }
}

ImageEmployee.propTypes = {
  gravatar: PropTypes.string,
  name: PropTypes.string,
}

export default ImageEmployee
